import { render } from "./RequestView.vue?vue&type=template&id=dc1d789c&scoped=true&ts=true"
import script from "./RequestView.vue?vue&type=script&lang=ts"
export * from "./RequestView.vue?vue&type=script&lang=ts"

import "./RequestView.vue?vue&type=style&index=0&id=dc1d789c&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc1d789c"]])

export default __exports__